export const getGridPosition = _ref => {
  let {
    column,
    width,
    height
  } = _ref;
  return {
    gridColumn: column + 1 + " / span " + width,
    gridRow: "auto / span " + height
  };
};
export const getGridContainerStyle = _ref2 => {
  let {
    columns,
    margin
  } = _ref2;
  const column = '1fr ';
  return {
    gridTemplateColumns: column.repeat(columns),
    gridAutoRows: 'minmax(min-content, max-content)',
    gap: margin.vertical + "px " + margin.horizontal + "px"
  };
};
//# sourceMappingURL=grid-options.js.map